import { jsxs as i, jsx as e } from "@emotion/react/jsx-runtime";
import { useTheme as c } from "@emotion/react";
import { successLightFixed as o } from "../utils.js";
import { StepState as h } from "./Step.types.js";
import { Stack as s } from "../../Stack/index.js";
import { Text as d } from "../../Text/index.js";
const m = () => /* @__PURE__ */ i("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ e("rect", { x: "1", y: "1", width: "22", height: "22", rx: "11", stroke: o, strokeWidth: "2" }),
  /* @__PURE__ */ e("circle", { cx: "12", cy: "12", r: "7", fill: o })
] }), p = () => {
  const t = c().colors.secondary.light;
  return /* @__PURE__ */ e("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ e("rect", { x: "0.5", y: "0.5", width: "23", height: "23", rx: "11.5", stroke: t }) });
}, w = () => /* @__PURE__ */ i("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ e("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z", fill: o }),
  /* @__PURE__ */ e("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0781 16.5498L6.16403 12.6388C6.05466 12.5289 5.99997 12.3875 5.99997 12.2147C5.99997 12.0419 6.05466 11.9006 6.16403 11.7906L7.03122 10.9425C7.14059 10.8168 7.27731 10.754 7.44138 10.754C7.60544 10.754 7.74997 10.8168 7.87497 10.9425L10.5 13.5812L16.125 7.92676C16.25 7.80111 16.3945 7.73828 16.5586 7.73828C16.7226 7.73828 16.8593 7.80111 16.9687 7.92676L17.8359 8.77493C17.9453 8.88488 18 9.02624 18 9.19901C18 9.37179 17.9453 9.51315 17.8359 9.6231L10.9218 16.5498C10.8125 16.6755 10.6718 16.7383 10.5 16.7383C10.3281 16.7383 10.1875 16.6755 10.0781 16.5498Z", fill: "white" })
] }), g = {
  active: m,
  completed: w,
  upcoming: p
}, y = ({
  title: n,
  state: t
}) => {
  const l = g[t], r = t === h.ACTIVE;
  return /* @__PURE__ */ i(s, { direction: "column", alignItems: "center", children: [
    /* @__PURE__ */ e(l, {}),
    /* @__PURE__ */ e(d, { variant: r ? "bodyMBold" : "bodyMRegular", color: r ? "default" : "secondary", children: n })
  ] });
};
export {
  y as Step
};
